import { render, staticRenderFns } from "./PrivacyBanner.vue?vue&type=template&id=13cf5f9a&scoped=true"
import script from "./PrivacyBanner.vue?vue&type=script&lang=js"
export * from "./PrivacyBanner.vue?vue&type=script&lang=js"
import style0 from "./PrivacyBanner.vue?vue&type=style&index=0&id=13cf5f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cf5f9a",
  null
  
)

export default component.exports